// Generated from the backend seed/roles.json. Display routing; the server still authorizes every request.
export const IDENTITY_ROLE_CLIENTS: Record<string, string> = {
  "learner_candidate": "learners",
  "sponsored_team_learner": "learners",
  "parent": "parents",
  "legal_guardian_authorized_adult": "parents",
  "instructor": "instructors",
  "mentor": "instructors",
  "instructor_and_assessor": "instructors",
  "instructor_lead": "instructors",
  "exam_proctor": "proctors",
  "integrity_reviewer": "proctors",
  "moderator_external_examiner": "proctors",
  "organization_owner": "organizations",
  "organization_member": "organizations",
  "organization_program_manager": "organizations",
  "organization_people_administrator": "organizations",
  "organization_team_manager": "organizations",
  "organization_governance_lead": "organizations",
  "organization_finance_administrator": "organizations",
  "organization_procurement_officer": "organizations",
  "organization_technical_administrator": "organizations",
  "organization_auditor": "organizations",
  "institution_owner_principal_administrator": "institutions",
  "institution_registrar": "institutions",
  "institution_dean": "institutions",
  "institution_head_of_department_program_leader": "institutions",
  "institution_quality_accreditation": "institutions",
  "institution_assessment_board_moderator": "institutions",
  "institution_student_success_wellbeing_accessibility": "institutions",
  "institution_research_ethics": "institutions",
  "institution_finance_procurement": "institutions",
  "institution_library_learning_resources": "institutions",
  "institution_information_security_it_integration": "institutions",
  "academy_operations_director": "admins",
  "admissions_officer": "admins",
  "onboarding_operations": "admins",
  "program_manager": "admins",
  "academic_reviewer": "admins",
  "content_author": "admins",
  "content_publisher": "admins",
  "instructor_operations": "admins",
  "assessment_operations": "admins",
  "credential_administrator": "admins",
  "organization_success": "admins",
  "institution_success": "admins",
  "community_moderator": "admins",
  "support_agent": "admins",
  "finance_administrator": "admins",
  "marketing_administrator": "admins",
  "compliance_officer": "admins",
  "internal_safeguarding_officer": "admins",
  "internal_accessibility_officer": "admins",
  "platform_administrator": "admins",
  "read_only_auditor": "admins"
};
